import { getPremiumEssentialsSafe } from '@wix/premium-fed-sdk/@premium-essentials';
import { BrokerOfferStatus } from '@wix/ambassador-premium-domains-v1-domain-broker-offer/types';
import { parseDomain } from '../../utils';
import { dynamicLoadApiQueries } from './dynamicLoadApiQueries';
export const isEligibleForBroker = async _ref => {
  let httpClient = _ref.httpClient,
    domain = _ref.request.domain;
  const _parseDomain = parseDomain(domain),
    asciiDomain = _parseDomain.asciiDomain,
    subdomain = _parseDomain.subdomain,
    parseError = _parseDomain.error;
  const isUnparseableDomain = Boolean(parseError) || !asciiDomain;
  const isSubdomain = Boolean(subdomain);
  if (isUnparseableDomain || isSubdomain) {
    return {
      isEligible: false
    };
  }
  const _await$dynamicLoadApi = await dynamicLoadApiQueries(httpClient),
    checkDomainIsTaken = _await$dynamicLoadApi.checkDomainIsTaken,
    queryDomainBrokerOffers = _await$dynamicLoadApi.queryDomainBrokerOffers;
  try {
    const _await$Promise$all = await Promise.all([checkDomainIsTaken({
        domain: asciiDomain
      }), queryDomainBrokerOffers({
        query: {
          filter: {
            domain: asciiDomain,
            status: {
              $eq: BrokerOfferStatus.IN_PROGRESS
            }
          },
          cursorPaging: {
            limit: 1
          }
        }
      })]),
      _await$Promise$all$ = _await$Promise$all[0],
      isAvailable = _await$Promise$all$.isAvailable,
      availabilityError = _await$Promise$all$.error,
      _await$Promise$all$1$ = _await$Promise$all[1].domainBrokerOffers,
      domainBrokerOffers = _await$Promise$all$1$ === void 0 ? [] : _await$Promise$all$1$;
    const isTaken = !isAvailable && !availabilityError;
    const hasOpenBrokerOffer = domainBrokerOffers.length > 0;
    return {
      isEligible: isTaken && !hasOpenBrokerOffer
    };
  } catch (error) {
    var _getPremiumEssentials;
    (_getPremiumEssentials = getPremiumEssentialsSafe()) == null || (_getPremiumEssentials = _getPremiumEssentials.panorama) == null || _getPremiumEssentials.errorMonitor().reportError(error instanceof Error ? error : new Error(String(error)), {
      tags: {
        errorType: 'isEligibleForBroker'
      }
    });
    return {
      isEligible: false
    };
  }
};
//# sourceMappingURL=isEligibleForBroker.js.map